import { gql } from "@apollo/client";

const TEMPLATE_WITH_SECTIONS = gql`
  query getDescriptionById($id: ID!) @api(name: "sanity") {
    allDocumentTemplate(where: { _id: { eq: $id } }) {
      _id
      description
    }
  }
`;

export default TEMPLATE_WITH_SECTIONS;
